/**
 * Schools that must never display campus flow lines, regardless of feature flag state.
 * ENG-7201: George Washington University is excluded permanently.
 */
export const CAMPUS_FLOW_DISABLED_SCHOOL_IDS = new Set([
  "d691fb7e-26ed-4bdb-9de4-9a0240f7fa2f", // George Washington University
])

export const FeatureFlags = {
  campus_flow: {
    flagKey: "ENG-4047_campus_flow",
    defaultValue: false,
  },
  floor_plans: {
    flagKey: "ENG-4907-Floor_Plans", // gitleaks:allow
    defaultValue: false,
  },
  map_view_by_school: {
    flagKey: "ENG-1398_map_view_by_school",
    defaultValue: false,
  },
  map_view_for_all: {
    flagKey: "ENG-6908_map_view_for_all",
    defaultValue: false,
  },
  upload_history: {
    flagKey: "ENG-2254_upload_history",
    defaultValue: false,
  },
  all_integrations: {
    flagKey: "ENG-6368_all_integrations",
    defaultValue: false,
  },
  zone_contrast_outlines: {
    flagKey: "ENG-4928_zone_contrast_outlines",
    defaultValue: false,
  },
  zone_data_rollback: {
    flagKey: "ENG-2255_zone_data_rollback",
    defaultValue: false,
  },
  dedicated_404_page: {
    flagKey: "ENG-7095_dedicated_404_page",
    defaultValue: false,
  },
}
